// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.faq-container {
    max-width: 100%;
    margin: 0 auto;
    margin-top: 110px;
    padding: 0px;
    font-family: Poppins, sans-serif;
    color: #333;
  }
  
  .faq-title {
    text-align: center;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 30px;
    color: #1a73e8;
  }
  
  /* FAQ List */
  .faq-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding:30px;
  }
  
  /* FAQ Items */
  .faq-item {
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f9f9f9;
    transition: background-color 0.3s;
  }
  
  .faq-item:hover {
    background-color: #f1f1f1;
  }
  
  /* FAQ Question */
  .faq-question {
    width: 100%;
    padding: 15px 20px;
    background-color: #e8f0fe;
    font-size: 1.2rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border: none;
    text-align: left;
    transition: background-color 0.3s;
  }
  
  .faq-question:hover {
    background-color: #d7e3fc;
  }
  
  /* FAQ Answer */
  .faq-answer {
    padding: 15px 20px;
    background-color: #ffffff;
    font-size: 1rem;
    color: #555;
    line-height: 1.6;
    text-align: left;
  }
  
  /* Lists within FAQ Answer */
  .faq-answer ul {
    padding-left: 20px;
    margin: 10px 0;
    list-style-type: disc;
  }
  
  .faq-answer ul li {
    margin-bottom: 5px;
  }
  
  .faq-answer ol {
    padding-left: 20px;
    margin: 10px 0;
    list-style-type: decimal;
  }
  
  .faq-answer ol li {
    margin-bottom: 5px;
  }
  
  /* Links */
  .faq-answer a {
    color: #1a73e8;
    text-decoration: none;
  }
  
  .faq-answer a:hover {
    text-decoration: underline;
  }
  
  /* Mobile Responsiveness */
  @media (max-width: 768px) {
    .faq-container{
      margin-top: 180px;
    }
    .faq-title {
      font-size: 2rem;
    }
  
    .faq-question {
      font-size: 1.1rem;
    }
  
    .faq-answer {
      font-size: 0.95rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Styles/FAQPage.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA,aAAa;EACb;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;EACd;;EAEA,cAAc;EACd;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,eAAe;EACf;IACE,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,UAAU;EACV;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,0BAA0B;EAC1B;IACE;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":["/* General Styles */\n.faq-container {\n    max-width: 100%;\n    margin: 0 auto;\n    margin-top: 110px;\n    padding: 0px;\n    font-family: Poppins, sans-serif;\n    color: #333;\n  }\n  \n  .faq-title {\n    text-align: center;\n    font-size: 2.5rem;\n    font-weight: bold;\n    margin-bottom: 30px;\n    color: #1a73e8;\n  }\n  \n  /* FAQ List */\n  .faq-list {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    padding:30px;\n  }\n  \n  /* FAQ Items */\n  .faq-item {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n    background-color: #f9f9f9;\n    transition: background-color 0.3s;\n  }\n  \n  .faq-item:hover {\n    background-color: #f1f1f1;\n  }\n  \n  /* FAQ Question */\n  .faq-question {\n    width: 100%;\n    padding: 15px 20px;\n    background-color: #e8f0fe;\n    font-size: 1.2rem;\n    font-weight: bold;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    border: none;\n    text-align: left;\n    transition: background-color 0.3s;\n  }\n  \n  .faq-question:hover {\n    background-color: #d7e3fc;\n  }\n  \n  /* FAQ Answer */\n  .faq-answer {\n    padding: 15px 20px;\n    background-color: #ffffff;\n    font-size: 1rem;\n    color: #555;\n    line-height: 1.6;\n    text-align: left;\n  }\n  \n  /* Lists within FAQ Answer */\n  .faq-answer ul {\n    padding-left: 20px;\n    margin: 10px 0;\n    list-style-type: disc;\n  }\n  \n  .faq-answer ul li {\n    margin-bottom: 5px;\n  }\n  \n  .faq-answer ol {\n    padding-left: 20px;\n    margin: 10px 0;\n    list-style-type: decimal;\n  }\n  \n  .faq-answer ol li {\n    margin-bottom: 5px;\n  }\n  \n  /* Links */\n  .faq-answer a {\n    color: #1a73e8;\n    text-decoration: none;\n  }\n  \n  .faq-answer a:hover {\n    text-decoration: underline;\n  }\n  \n  /* Mobile Responsiveness */\n  @media (max-width: 768px) {\n    .faq-container{\n      margin-top: 180px;\n    }\n    .faq-title {\n      font-size: 2rem;\n    }\n  \n    .faq-question {\n      font-size: 1.1rem;\n    }\n  \n    .faq-answer {\n      font-size: 0.95rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
